import { Component, computed, effect, inject, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProgressBarModule } from 'primeng/progressbar';
import { PT_BR_CONFIG } from './common/languages/primeng-config-pt-br';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ProgressBarService } from '@common/services/progress-bar.service';
import { NotifyService } from '@common/services/notify.service';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  imports: [
    ProgressBarModule,
    RouterOutlet,
    ToastModule
  ],
  providers: [
    ConfirmationService,
    MessageService
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private config = inject(PrimeNG);
  private messageService = inject(MessageService);

  private notifications = inject(NotifyService).notifications;

  private progressBarService = inject(ProgressBarService);
  showProgressBar = computed(() => this.progressBarService.progressBar());

  private subscritpion: Subscription;
  title = 'DJCer Web 0.0.1';

  constructor() {
    this.subscritpion = new Subscription();

    effect(() => {
      if (this.notifications().length > 0) {
        this.messageService.addAll(this.notifications());
      }
    })
  }

  async ngOnInit() {
    this.config.setTranslation(PT_BR_CONFIG);
  }

  ngOnDestroy(): void {
    if (this.subscritpion) {
      this.subscritpion.unsubscribe();
    }
  }
}
